import { cn } from '../lib/cn.js';

/** Marca neutra da plataforma (usada só no painel da equipe; o paciente nunca a vê). */
export function BrandMark({ className, compact }: { className?: string; compact?: boolean }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <svg viewBox="0 0 32 32" className="size-7 shrink-0" aria-hidden>
        <rect width="32" height="32" rx="8" fill="var(--dnx-brand)" />
        <path d="M10 9.5h6.2c4.3 0 7.3 2.7 7.3 6.5s-3 6.5-7.3 6.5H10z" fill="none" stroke="white" strokeWidth="2.4" strokeLinejoin="round" />
        <circle cx="16" cy="16" r="2.1" fill="white" />
      </svg>
      {!compact && (
        <span className="text-[15px] font-semibold tracking-tight">
          Domnexus <span className="font-normal text-fg-muted">Capilar</span>
        </span>
      )}
    </span>
  );
}
